var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEthiopiaEmployees(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 193,
    viewBox: "0 0 76 193",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.1149 86.5789L38.0259 192.33L26.8047 86.5789C34.0529 88.9469 41.8666 88.9469 49.1149 86.5789Z",
    fill: "#0F47AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38 78.5904C58.9868 78.5904 76 60.9973 76 39.2952C76 17.5931 58.9868 0 38 0C17.0132 0 0 17.5931 0 39.2952C0 60.9973 17.0132 78.5904 38 78.5904Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1223_4",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 76,
    height: 79
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38 78.5904C58.9868 78.5904 76 60.9973 76 39.2952C76 17.5931 58.9868 0 38 0C17.0132 0 0 17.5931 0 39.2952C0 60.9973 17.0132 78.5904 38 78.5904Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1223_4)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0039 78.5904C58.9907 78.5904 76.0039 60.9973 76.0039 39.2952C76.0039 17.5931 58.9907 0 38.0039 0C17.0171 0 0.00390625 17.5931 0.00390625 39.2952C0.00390625 60.9973 17.0171 78.5904 38.0039 78.5904Z",
    fill: "#078930"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1223_4",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 77,
    height: 79
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0039 78.5904C58.9907 78.5904 76.0039 60.9973 76.0039 39.2952C76.0039 17.5931 58.9907 0 38.0039 0C17.0171 0 0.00390625 17.5931 0.00390625 39.2952C0.00390625 60.9973 17.0171 78.5904 38.0039 78.5904Z",
    fill: "#DA121A"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1223_4)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.503906,
    y: 40.4907,
    width: 75.9194,
    height: 59.7232,
    fill: "#DA121A"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.503906 14.1711H76.4277V64.6567H-0.503906V14.1711Z",
    fill: "#FCDD09"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.503906 47.8287H76.4277V64.6567H-0.503906V47.8287Z",
    fill: "#DA121A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.503906 14.1711H76.4277V30.9991H-0.503906V14.1711Z",
    fill: "#078930"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9619 55.266C46.7172 55.266 53.8148 48.1684 53.8148 39.4131C53.8148 30.6577 46.7172 23.5601 37.9619 23.5601C29.2066 23.5601 22.109 30.6577 22.109 39.4131C22.109 48.1684 29.2066 55.266 37.9619 55.266Z",
    fill: "#0F47AF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9713 49.8156C31.8666 49.8149 31.7633 49.7919 31.6683 49.7481C31.5733 49.7042 31.4887 49.6406 31.4203 49.5614C31.3519 49.4822 31.3012 49.3893 31.2716 49.2889C31.242 49.1885 31.2342 49.083 31.2488 48.9793L32.2355 42.385L27.3637 37.8326C27.2638 37.7395 27.1919 37.6202 27.1563 37.4883C27.1207 37.3564 27.1227 37.2171 27.1623 37.0864C27.2018 36.9556 27.2772 36.8385 27.3799 36.7484C27.4826 36.6583 27.6086 36.5988 27.7434 36.5766L34.3194 35.4795L37.1441 29.4387C37.2021 29.3151 37.2936 29.2102 37.4081 29.1358C37.5226 29.0614 37.6557 29.0205 37.7922 29.0177C37.9287 29.0149 38.0633 29.0504 38.1808 29.12C38.2983 29.1897 38.3939 29.2908 38.457 29.412L41.5325 35.3273L48.1503 36.1468C48.2857 36.1639 48.4135 36.2185 48.5195 36.3043C48.6255 36.3902 48.7054 36.5039 48.7503 36.6327C48.7951 36.7615 48.8031 36.9003 48.7733 37.0334C48.7436 37.1665 48.6773 37.2886 48.5818 37.3861L43.899 42.1391L45.1717 48.6766C45.1975 48.8107 45.1854 48.9493 45.1366 49.0768C45.0878 49.2043 45.0043 49.3156 44.8956 49.3982C44.787 49.4808 44.6573 49.5314 44.5214 49.5443C44.3855 49.5572 44.2487 49.5318 44.1265 49.471L38.1609 46.5025L32.3258 49.7236C32.2172 49.7834 32.0953 49.815 31.9713 49.8156ZM29.4476 37.7741L33.5166 41.5772C33.6032 41.6584 33.6689 41.7594 33.7079 41.8715C33.747 41.9837 33.7582 42.1036 33.7407 42.2211L32.9145 47.7284L37.7947 45.0307C37.8984 44.9732 38.0146 44.9417 38.1331 44.9391C38.2517 44.9365 38.3692 44.9628 38.4753 45.0157L43.4542 47.5059L42.3955 42.0371C42.3732 41.9208 42.3796 41.8008 42.4139 41.6875C42.4483 41.5741 42.5097 41.4709 42.5929 41.3865L46.4913 37.4112L40.9723 36.7272C40.8547 36.7125 40.7425 36.6695 40.6452 36.6019C40.5479 36.5343 40.4685 36.4442 40.4137 36.3391L37.8432 31.3971L35.4851 36.4428C35.4343 36.5502 35.3584 36.6436 35.2638 36.7153C35.1691 36.7869 35.0586 36.8346 34.9415 36.8543L29.4476 37.7741Z",
    fill: "#FCDD09"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthiopiaEmployees);
export default __webpack_public_path__ + "static/media/ethiopiaEmployees.3c3ed2d03e5009ba52b460cadc55c686.svg";
export { ForwardRef as ReactComponent };